module.exports = __webpack_public_path__ + "img/burger-menu-1.a4c65c19.jpg";